export default function TestimonialSection() {
  return (
    <section className="relative py-28 md:py-36 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-16">
        <div className="relative bg-primary-900 rounded-[32px] overflow-hidden flex flex-col lg:flex-row">
          {/* Left Image */}
          <div className="w-full lg:w-[35%] relative">
            <img
              src="https://readdy.ai/api/search-image?query=Happy%20confident%20person%20in%20modern%20loft%20apartment%20wearing%20trendy%20casual%20streetwear%20outfit%20with%20designer%20sneakers%2C%20natural%20window%20light%20streaming%20in%2C%20editorial%20portrait%20photography%2C%20warm%20cream%20walls%20background%2C%20sophisticated%20urban%20lifestyle%20aesthetic%2C%20genuine%20smile%2C%20clean%20contemporary%20composition%2C%20relaxed%20authentic%20pose&width=700&height=900&seq=testi-v2-portrait-x1&orientation=portrait"
              alt="Comprador HoobuySpreadsheet"
              title="HoobuySpreadsheet - Comunidade de Compradores"
              className="w-full h-[400px] lg:h-full object-cover object-top"
            />
          </div>

          {/* Right Content */}
          <div className="w-full lg:w-[65%] p-10 md:p-16 flex flex-col justify-center relative">
            {/* Decorative quote */}
            <span className="absolute top-10 right-10 text-8xl font-heading text-accent-400/20 leading-none select-none">
              &ldquo;
            </span>

            <blockquote className="relative z-10">
              <p className="text-lg md:text-xl text-background-50/90 leading-relaxed max-w-lg font-heading italic">
                &ldquo;O hoobuyspreadsheet mudou completamente a forma como faço compras internacionais. Antes eu passava horas pesquisando em fóruns, agora encontro tudo organizado em uma única planilha. Já economizei mais de 40% nas minhas últimas compras usando as listas verificadas.&rdquo;
              </p>
            </blockquote>

            <div className="mt-8 relative z-10">
              <p className="text-sm font-semibold text-background-50 whitespace-nowrap">Marina Costa</p>
              <p className="text-xs text-background-50/50 mt-0.5 whitespace-nowrap">Compradora Frequente desde 2025</p>
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-8 relative z-10 inline-flex items-center gap-2 h-12 px-7 rounded-full bg-accent-400 text-primary-900 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-accent-300 transition-colors w-fit"
            >
              Verificar na Planilha
              <i className="ri-arrow-right-up-line text-base w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}